import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c06d1f22 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _68e628a7 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _e0bcda6c = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _585093d8 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _19961a98 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _6968db7c = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _0a575900 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _4d5d274a = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7fae82a4 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _2a68a545 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _6671eb4e = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _5f5ab152 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _fa8b4d46 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _38e25498 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _252b692c = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _8251e7d2 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _8798ad84 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _93dcfc18 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _ead12032 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _e84a8172 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5cb972c4 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _7ea55c7e = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _3e3bc6b2 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _336bc07b = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _3f5b5681 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _c7ebc578 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _5ebb0a86 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _5c12cafc = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _a77bc14c = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _1d4ec264 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _eb1cd5f6 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _427feb68 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _6e22003e = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _76f53419 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _b799c4ca = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _a111e92e = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _db306978 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _e47d778c = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _70a26844 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _3b6a4b2c = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _e9b707a8 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _789eb6b8 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _199e4b07 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _3b084006 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _635dfe89 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _21c1a756 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _158e85ff = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _29b290ce = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _09e72be1 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _09fcd89a = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _62bcf57a = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _78561242 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _a5678d46 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _5bdf7acf = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6d5977fc = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _263c2832 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _fc80b0c8 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _2e018bc3 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _8e43a8fc = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _28d59ea6 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _23d73991 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _dae14738 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _1364f2ee = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _6b792e7e = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _5d9062a8 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _12f27ad2 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _f9ac809c = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _40593690 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _35efdbc8 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _c4f643e8 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _0b15cf01 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _4a12c4cd = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _a2b90f3e = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _d1e224e2 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _0235e56e = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _2e40937f = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _c06d1f22,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _68e628a7,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _e0bcda6c,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _585093d8,
    name: "calendar"
  }, {
    path: "/customer",
    component: _19961a98,
    name: "customer"
  }, {
    path: "/details",
    component: _6968db7c,
    name: "details"
  }, {
    path: "/goals",
    component: _0a575900,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _4d5d274a,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7fae82a4,
    name: "media"
  }, {
    path: "/privacy",
    component: _2a68a545,
    name: "privacy"
  }, {
    path: "/project",
    component: _6671eb4e,
    name: "project"
  }, {
    path: "/response",
    component: _5f5ab152,
    name: "response"
  }, {
    path: "/sale",
    component: _fa8b4d46,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _38e25498,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _252b692c,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _8251e7d2,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _8798ad84,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _93dcfc18,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _ead12032,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _e84a8172,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5cb972c4,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _7ea55c7e,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _3e3bc6b2,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _336bc07b,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _3f5b5681,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _c7ebc578,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _5ebb0a86,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _5c12cafc,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _a77bc14c,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _1d4ec264,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _eb1cd5f6,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _427feb68,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _6e22003e,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _76f53419,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _b799c4ca,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _a111e92e,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _db306978,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _e47d778c,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _70a26844,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _3b6a4b2c,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _e9b707a8,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _789eb6b8,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _199e4b07,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _3b084006,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _635dfe89,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _21c1a756,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _158e85ff,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _29b290ce,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _09e72be1,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _09fcd89a,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _62bcf57a,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _78561242,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _a5678d46,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _5bdf7acf,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _6d5977fc,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _263c2832,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _fc80b0c8,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _2e018bc3,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _8e43a8fc,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _28d59ea6,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _23d73991,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _dae14738,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _1364f2ee,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _6b792e7e,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _5d9062a8,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _12f27ad2,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _f9ac809c,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _40593690,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _35efdbc8,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _c4f643e8,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _0b15cf01,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _4a12c4cd,
    name: "property-property",
    children: [{
      path: "contact",
      component: _a2b90f3e,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _d1e224e2,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _0235e56e,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _2e40937f,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
